import { render, staticRenderFns } from "./SelfReflection.vue?vue&type=template&id=08b9e175&scoped=true&"
import script from "./SelfReflection.vue?vue&type=script&lang=js&"
export * from "./SelfReflection.vue?vue&type=script&lang=js&"
import style0 from "./SelfReflection.vue?vue&type=style&index=0&id=08b9e175&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b9e175",
  null
  
)

export default component.exports